if (!customElements.get('drawer')) {
  class DrawerElement extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector('.js-offcanvas-close'); 
      this.boundToggleDrawer = this.toggleDrawer.bind(this);
      this.open = false;
    }

    connectedCallback() {
      this.id = this.dataset.id ?? '';
      this.openButton = document.querySelector(`[data-drawer-open="${this.id}"]`);
      this.overlay = document.querySelector(`[data-drawer-id="${this.id}"]`);
      if (this.overlay) this.overlay.addEventListener('click', this.boundToggleDrawer);
      if (this.closeButton) this.closeButton.addEventListener('click', this.boundToggleDrawer);
      if (this.openButton) this.openButton.addEventListener('click', this.boundToggleDrawer);
    }

    disconnectedCallback() {
      if (this.overlay) this.overlay.removeEventListener('click', this.boundToggleDrawer);
      if (this.closeButton) this.closeButton.removeEventListener('click', this.boundToggleDrawer);
      if (this.openButton) this.openButton.removeEventListener('click', this.boundToggleDrawer);
    }

    toggleDrawer() {
      this.classList.toggle('is-expanded');
      this.open = !this.open;

      if(this.open && this.overlay) {
        this.overlay.classList.add('has-open-drawer');
        document.body.style.overflow = 'hidden';
      } else if(!this.open && this.overlay) {
        this.overlay.classList.remove('has-open-drawer');
        document.body.style.overflow = 'auto';
      }
    }
  }

  customElements.define('drawer-element', DrawerElement);
}
